export default __webpack_public_path__ + "static/media/pet_2.b0c28d98.jpg";